import { TrendingUp, Activity, ArrowUpRight, ArrowDownRight, Zap, DollarSign } from 'lucide-react';

export const SCREENER_PRESETS = [
  { id: 'momentum', name: 'High Momentum', description: 'Positive change, ranked by % move', icon: TrendingUp },
  { id: 'volume', name: 'Volume Spike', description: 'Highest volume vs 30-day avg', icon: Activity },
  { id: 'gainers', name: 'Top Gainers', description: 'Biggest daily gainers', icon: ArrowUpRight },
  { id: 'losers', name: 'Top Losers', description: 'Biggest daily decliners', icon: ArrowDownRight },
  { id: 'unusual', name: 'Unusual Volume', description: 'Volume ratio > 1.5×', icon: Zap },
  { id: 'value', name: 'Value (Low P/E)', description: 'P/E ≤ 25, sorted ascending', icon: DollarSign },
];

export const SCREENER_SECTORS = [
  { id: '', label: 'All Sectors' },
  { id: 'tech', label: 'Technology' },
  { id: 'finance', label: 'Finance' },
  { id: 'healthcare', label: 'Healthcare' },
  { id: 'energy', label: 'Energy' },
  { id: 'consumer', label: 'Consumer' },
  { id: 'industrial', label: 'Industrial' },
  { id: 'communication', label: 'Communication' },
];

export const formatMarketCap = (mc) => {
  if (!mc) return 'N/A';
  if (mc >= 1e12) return `$${(mc / 1e12).toFixed(2)}T`;
  if (mc >= 1e9) return `$${(mc / 1e9).toFixed(1)}B`;
  if (mc >= 1e6) return `$${(mc / 1e6).toFixed(0)}M`;
  return `$${mc.toFixed(0)}`;
};
